export enum SliceType {
  Automation = 'automation',
  Chatbot = 'chatbot',
  Client = 'client',
  Dashboards = 'dashboards',
  DashboardV2 = 'dashboard_v2',
  DocumentEditors = 'documentEditors',
  DocumentsNavigation = 'documentsNavigation',
  DocumentGroup = 'Document Group',
  FieldAi = 'fieldAi',
  Pages = 'pages',
  SearchV3 = 'search_v3',
  Upload = 'upload',
  Webhooks = 'webhooks',
  XRay = 'xRay',
  xRayDebug = 'xRayDebug',
  XRayLibrary = 'xRayLibrary',
}
